module.exports = __webpack_public_path__ + "media/flowplayer_v7/skin/icons/flowplayer-b7f18391365fc63d0a5d60f4a0934138.woff2";